import Select from 'antd/es/select';
import { useMemo, useState } from 'react';
import { CountryFlag } from 'shared/src/CountryFlag';

import { useGetCoreCountries } from 'api';

type Props = {
  onChange: (value: string) => void;
  errorMessage?: string;
  value?: string;
  'data-testid'?: string;
  placeholder?: string;
  disabled?: boolean;
  allowClear?: boolean;
  showSearch?: boolean;
};

export const SelectCountry = ({
  onChange,
  value,
  'data-testid': dataTestId,
  placeholder = 'Select country',
  disabled = false,
  allowClear = true,
  showSearch = true
}: Props) => {
  const [hasSearchValue, setHasSearchValue] = useState(false);

  const { data } = useGetCoreCountries();

  const countryOptions = useMemo(() => {
    return data?.data.map((country) => ({
      value: country.iso,
      label: (
        <div className="flex flex-row items-center gap-2">
          <CountryFlag className="!size-[18px]" countryCode={country.iso} svg />
          {country.name} ({country.iso})
        </div>
      ),
      searchLabel: country.name + country.iso,
      key: country.id
    }));
  }, [data]);

  return (
    <>
      <Select
        className="min-w-[300px]"
        value={value}
        options={countryOptions}
        onChange={onChange}
        onSearch={(value) => setHasSearchValue(!!value)}
        disabled={disabled}
        data-testid={dataTestId}
        placeholder={placeholder}
        allowClear={!!(value || hasSearchValue) && allowClear}
        showSearch={showSearch}
        filterOption={(input, option) =>
          (option?.searchLabel ?? '')
            .toLowerCase()
            .includes(input.toLowerCase())
        }
      />
    </>
  );
};
